import React from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import NotificationSystem from 'react-notification-system';
import Scrollbars from 'react-custom-scrollbars';
import Footer from './components/layout/footer/footer';
import Header from './components/layout/header/header';
import Sidebar from './components/layout/sidebar/sidebar';
import { logOutUser } from './actions/authenticateActions';
import AdminHome from './containers/admin/adminHome.jsx';
import DispatcherHome from './containers/dispatcher/dispatcherHome';
import ReportsHome from './containers/reports/reportsHome';
import * as notificationActions from './actions/notificationActions';
import Admin from './components/launchComponents/Admin/admin';
import DispatcherDashboarPage from './containers/launch/dashboard/dispatcherDashboardPage';
import Reports from './components/launchComponents/Reports/reports';
import AdminAccountDetailPage from './containers/launch/adminAccountDetail/adminAccountDetailPage';
import ReportChartPage from './containers/launch/reportChart/reportChartPage';
import { PrivateRoute } from './components/route/privateRoute';
import { fillDropDownsData } from './util/customMethods';
import { isAuthenticated } from './util/authValidator';

/**
 * Home Component — Authenticated Shell
 * ─────────────────────────────────────────────────────
 * CHANGES:
 *  1. Removed deprecated componentWillMount (was empty anyway)
 *  2. Replaced string refs with React.createRef()
 *  3. Uses authValidator.isAuthenticated instead of authenticateActions.isAuthenticated
 *  4. Fixed typo: "eaxct" → "exact" on reports-dashboard route
 *  5. Bound fillDropDowns via arrow function (removed manual bind in constructor)
 */

const PAYMENT_POPUP_ROUTES = ['/dispatch/payment'];

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.notificationRef = React.createRef();
  }

  componentDidMount() {
    const { dispatch } = this.props;

    if (this.notificationRef.current) {
      dispatch(notificationActions.setNotificationRef(this.notificationRef.current));
    }

    this.fillDropDowns();
  }

  fillDropDowns = () => {
    const { dispatch } = this.props;
    if (isAuthenticated()) {
      dispatch(fillDropDownsData());
    }
  };

  isPaymentPopupRoute = () => {
    return PAYMENT_POPUP_ROUTES.includes(this.props.location.pathname);
  };

  render() {
    const isPaymentPopup = this.isPaymentPopupRoute();

    return (
      <>
        <NotificationSystem ref={this.notificationRef} />

        {!isPaymentPopup && (
          <div className="header clearfix">
            <Header
              onLogOut={() => this.props.dispatch(logOutUser())}
              reviewInbox={this.props.reviewInbox}
              accessLevels={this.props.accessLevel || {}}
              dashboardAccess={this.props.dashboardAccess}
            />
          </div>
        )}

        {!isPaymentPopup && (
          <div id="side-bar" className="left-side-bar">
            <Sidebar
              accessLevels={this.props.accessLevel || {}}
              dashboardAccess={this.props.dashboardAccess}
            />
          </div>
        )}

        <Scrollbars style={{ height: '100vh' }}>
          <div
            className={isPaymentPopup ? 'payment-popup-container' : 'pd-ltr-20'}
            style={{ marginBottom: '50px' }}
          >
            <div className="main-container" style={{ marginBottom: '50px', height: 'auto' }}>
              <Route exact path="/admin-dashboard" component={Admin} />
              <Route exact path="/summarydashboard" component={DispatcherDashboarPage} />
              <Route exact path="/reports-dashboard" component={Reports} />
              <Route path="/reportschart" component={ReportChartPage} />
              <Route path="/adminaccountdetail" component={AdminAccountDetailPage} />
              <Route path="/admin" component={AdminHome} />
              <Route path="/dispatch" component={DispatcherHome} />
              <Route path="/reports" component={ReportsHome} />
              <Route exact path="/" component={DispatcherDashboarPage} />

              {!isPaymentPopup && <Footer />}
            </div>
          </div>
        </Scrollbars>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  authInfo: state.authInfo,
  accessLevel: state.accessLevel,
  dashboardAccess: state.dashboardAccess,
  refNotify: state.refNotify,
  reviewInbox: state.reviewInbox.reviewLocationList,
});

export default connect(mapStateToProps)(Home);
